import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledPopupDiv } from '../../atoms/popup/popup.styles';
import { StyledPopupHeaderDiv } from '../../atoms/popupHeader/popupHeader.styles';

export const SearchDesktopPrimary = styled.div.attrs((props: { desktopFormHeight: number }) => props)`
  ${rtl`
  box-shadow: ${theme.color['container-box-shadow']};
  display: flex;
  align-items: flex-start;
  padding-right: 0;
  // height: 100%;
  min-height: ${toRem(88)};
  max-height: ${toRem(88)};
  background-color: ${theme.color.white};
  position: relative;
  margin: 0 auto !important;
  &.br-full {
    border-radius: ${toRem(14)};
  }
  &.br-half {
    border-radius: ${toRem(14)} ${toRem(14)} 0 0;
  }
  &.br-0 {
    border-radius:0;
  }
  &.shop-page-search-primary {
    display: flex;
    align-items: center;
    .adf-search-desktop {
      border-right:${toRem(1)} dashed ${theme.color['dark-gray-6']};
      padding: 0;

      .search-dates-wrapper {
        padding-left: 0;
      }
    }
    .shop-dates-wrapper {

    }
    .shop-destination-wrapper {
      min-height: ${() => toRem(88) || 0};
      padding-top: ${toRem(5)};
      ${StyledPopupDiv} {
        &.search-page-destination.custom-search-popup {
          ${StyledPopupHeaderDiv} {
            .with-input {
              padding-top: ${toRem(15)};
              padding-bottom: ${toRem(3)};
              padding-left:${toRem(15)};
            }
          }
        }
      }
      &:after {
        content: '';
        border-right: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
        height: ${toRem(44)};
        position: absolute;
        right: ${toRem(3)};
        top: ${toRem(24)};
        @media ${theme.mediaQuery.mobileTablet} {
          right: ${toRem(-5)};
        }
        @media ${theme.mediaQuery.desktop} {
          top: ${toRem(23)};
        }
      }
      @media ${theme.mediaQuery.mobileTablet} {
        &.shop-page-split-date-box-destination {
          flex: 0 0 30.34%;
          max-width: 30.34%;
        }
        flex: 0 0 36.34%;
        max-width: 36.34%;
        padding-right: ${toRem(20)};
      }
      @media ${theme.mediaQuery.desktop} {
        &.shop-page-split-date-box-destination {
          flex: 0 0 33%;
          max-width: 33%;
        }
        flex: 0 0 39%;
        max-width: 38.7%;
      }
    }
  }

  > button {
    align-self: center;
  }
  input:focus {
    border: none;
    outline: none;
  }
  button:focus {
     outline: revert;
  }

  .search__container-hide-destination {
    .search-primary {
      box-shadow: 0 4px 8px 0 rgb(0 0 0 / 5%);
    }

    .search-primary-destination {
      display: none !important;
    }
  }
`}
`;
